// new one with sub category
import React, { useEffect, useState, useRef } from "react";
import { useNavigate, Link } from "react-router-dom";
import Header from "./Header";
import Loader from "./Utils/Loader";
import Select from "react-select";

import {
  Userlogin,
  GetDealerdata,
  Toast,
  shareIphonePostMsg,
  handlePostApiGF,
  handleGetApiGF,
  customStyles,
} from "./Utils/general-function";
import html2canvas from "html2canvas";

export function Test(props) {
  async function testShareDemo() {
    const url = "https://m.carthi.in/car/123";
    const title = "Carthi Demo Share";
    const text = "Check this car on Carthi!";
    const imgUrl =
      "https://apps.carthi.in/Content/Carimage/GJ08BN1223_FirstPhoto_aovuJ8d.png?v=1765253420000"; // random image

    try {
      // Convert image URL → File
      const response = await fetch(imgUrl);
      const blob = await response.blob();
      const file = new File([blob], "demo.jpg", { type: blob.type });
      console.log("file", file);

      const canShareFile = navigator.canShare?.({ files: [file] });

      if (canShareFile) {
        // 🔥 Full share (Android)
        await navigator.share({
          files: [file],
          text,
          // title,
          // url,
        });
        window.location.href = "https://wa.me/?text=hello";

        alert("Shared with image!");
      } else {
        // 🔥 Fallback for iOS / Unsupported
        await navigator.share({
          title,
          text,
          url,
        });
        alert("Shared without image!");
      }
    } catch (e) {
      console.log("Share failed:", e);
      alert("Share failed: " + e.message);
    }
  }

  return (
    <div>
      <Header />
      <button onClick={testShareDemo}>Test Share Demo</button>
    </div>
  );
}
